
// Utility function to sanitize text output to prevent XSS
export const sanitizeText = (text: string | null | undefined): string => {
  if (!text) return '';
  return text
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
};

// Currency formatting utility
export const formatCurrency = (amount: number | null | undefined, currency = 'USD', decimals = 2): string => {
  if (!amount) return decimals === 0 ? '$0' : '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount);
};

// Address formatting utility
export const formatContactAddress = (address: any): { line1: string; line2: string } | null => {
  if (!address || typeof address !== 'object') {
    return null;
  }

  const { line1, line2, city, state, zip } = address;
  
  // If no address data at all, return null
  if (!line1 && !line2 && !city && !state && !zip) {
    return null;
  }

  // Format first line: line1 + line2 (if both exist)
  const firstLine = line1 ? (line2 ? `${line1}, ${line2}` : line1) : (line2 || '');
  
  // Format second line: city, state zip
  const cityStateZip = [city, state].filter(Boolean).join(', ');
  const secondLine = zip ? (cityStateZip ? `${cityStateZip} ${zip}` : zip) : cityStateZip;

  return {
    line1: firstLine || '',
    line2: secondLine || ''
  };
};

// Date formatting utilities
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateString: string): string => {
  return new Date(dateString).toLocaleString();
};

export const formatStartTime = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, '0');
  
  return `${month}/${day}/${year} ${displayHours}:${displayMinutes} ${ampm}`;
};
